import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Staff {
	id: number;
	first_name: string;
	last_name: string;
	full_name: string;
	email: string;
	phone: string;
	role: 'stylist' | 'consultant';
	working_hours_start: string;
	working_hours_end: string;
	is_active: boolean;
	created_at: string;
	updated_at: string;
}

export interface ApiResponse<T> {
	status: boolean;
	data: T;
	message?: string;
}

@Injectable({
	providedIn: 'root',
})
export class StaffService {
	private http = inject(HttpClient);
	private apiUrl = environment.apiUrl;

	// Admin APIs
	getAll(): Observable<ApiResponse<Staff[]>> {
		return this.http.get<ApiResponse<Staff[]>>(`${this.apiUrl}/admin/staff`);
	}

	getById(id: number): Observable<ApiResponse<Staff>> {
		return this.http.get<ApiResponse<Staff>>(`${this.apiUrl}/admin/staff/${id}`);
	}

	create(data: Partial<Staff>): Observable<ApiResponse<Staff>> {
		return this.http.post<ApiResponse<Staff>>(`${this.apiUrl}/admin/staff`, data);
	}

	update(id: number, data: Partial<Staff>): Observable<ApiResponse<Staff>> {
		return this.http.put<ApiResponse<Staff>>(`${this.apiUrl}/admin/staff/${id}`, data);
	}

	delete(id: number): Observable<ApiResponse<null>> {
		return this.http.delete<ApiResponse<null>>(`${this.apiUrl}/admin/staff/${id}`);
	}

	// Public API
	getActive(): Observable<ApiResponse<Staff[]>> {
		return this.http.get<ApiResponse<Staff[]>>(`${this.apiUrl}/public/staff`);
	}
}
